import React from "react";
import PropTypes from "prop-types";
import {
  Typography, Box, Button, Divider, Alert,
  Stack, Avatar, Chip,
} from "@mui/joy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import avatar from "../../../Male_Avatar.jpg";

const ContactPage = ({ representative, setOpen }) => {
  const goToRepWebsite = () => {
    window.open(representative.officialWebsiteUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <Typography sx={{ fontSize: "22px", fontWeight: 700, color: "#171a1c", mb: "6px" }}>
        Your Representative
      </Typography>
      <Typography sx={{ fontSize: "15px", color: "#535862", lineHeight: 1.6, mb: "20px" }}>
        Based on your address, here is your district representative in Congress.
      </Typography>

      <Alert
        variant="soft"
        color="success"
        size="sm"
        startDecorator={<CheckCircleOutlineIcon sx={{ fontSize: "16px" }} />}
        sx={{ mb: "20px", fontSize: "13px" }}
      >
        {representative.fullName} represents your district.
      </Alert>

      {/* Rep card */}
      <Box
        sx={{
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          p: "20px",
          mb: "24px",
        }}
      >
        <Stack direction="row" spacing="16px" alignItems="center" sx={{ mb: "16px" }}>
          <Avatar
            src={representative.imageUrl || avatar}
            alt={representative.fullName || "Representative"}
            sx={{ width: 64, height: 64, flexShrink: 0 }}
          />
          <Box>
            <Typography sx={{ fontSize: "17px", fontWeight: 700, color: "#171a1c" }}>
              {representative.fullName}
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "#535862", mt: "2px" }}>
              {representative.party}
            </Typography>
          </Box>
        </Stack>

        <Divider sx={{ mb: "16px" }} />

        <Stack direction="row" spacing="8px" flexWrap="wrap" useFlexGap>
          {representative.state && (
            <Chip size="sm" variant="soft" color="neutral" sx={{ fontSize: "12px" }}>
              {representative.state}
            </Chip>
          )}
          {representative.district && (
            <Chip size="sm" variant="soft" color="neutral" sx={{ fontSize: "12px" }}>
              District {representative.district}
            </Chip>
          )}
        </Stack>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Button
          fullWidth
          size="lg"
          endDecorator={<OpenInNewIcon />}
          onClick={goToRepWebsite}
          sx={{
            backgroundColor: "#003049",
            color: "white",
            fontWeight: 600,
            fontSize: "16px",
            borderRadius: "6px",
            minHeight: "48px",
            "&:hover": { backgroundColor: "#00243a" },
          }}
        >
          Visit their official website
        </Button>
        <Button
          fullWidth
          variant="plain"
          color="neutral"
          onClick={() => setOpen(false)}
          sx={{ fontSize: "15px", fontWeight: 500 }}
        >
          Close
        </Button>
      </Box>
    </>
  );
};

ContactPage.propTypes = {
  setOpen: PropTypes.func.isRequired,
  representative: PropTypes.object.isRequired,
};

export default ContactPage;
